import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import BorderedLayout from "../../layouts/BorderedLayout";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useMutation } from "react-query";
import {
  GetCollaborationStoreZipFile,
  IsVisitCollaborationStore,
} from "../../services/collaborationStores.service";
import { useHistory } from "react-router-dom";
import { GetCollaborationStoresResponse } from "../../models/collaborationStores.model";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";

const CollaborationStoreDetail = () => {
  const [collaborationStore, setCollaborationStore] = useState<
    GetCollaborationStoresResponse
  >();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const history = useHistory<{
    key: string;
  }>();

  const collaborationStoreKey =
    history?.location?.state?.key !== undefined
      ? history?.location?.state?.key
      : window.localStorage.getItem("DETAIL_COLLABORATION");

  console.log({ collaborationStoreKey });
  const { mutate: GetCollaborationStoreZipFileMutate } = useMutation(
    GetCollaborationStoreZipFile,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    },
  );
  const { mutate: IsVisitCollaborationStoreMutate } = useMutation(
    IsVisitCollaborationStore,
    {
      onSuccess: (data: GetCollaborationStoresResponse) => {
        if (data) {
          setCollaborationStore(data);
        }
      },
      onError: () => {},
    },
  );

  const handleDownloadDocs = () => {
    GetCollaborationStoreZipFileMutate({
      key: collaborationStoreKey!,
      companyName: collaborationStore?.companyName!,
    });
  };
  useEffect(() => {
    IsVisitCollaborationStoreMutate({
      key: collaborationStoreKey!,
    });
  }, []);
  return (
    <div>
      <Grid
        container
        sx={{
          backgroundColor: "#F6F8F9",
          border: "1px solid #EDEFEF",
          borderRadius: "5px",
          padding: "10px 25px",
          alignItems: "center",
          justifyContent: "flex-end",
          mb: "20px",
        }}
      >
        <Grid item>
          <Box
            sx={{
              display: { xs: "block", md: "flex" },
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Typography
              sx={{ color: "#28A745", cursor: "pointer" }}
              onClick={() => {
                handleDownloadDocs();
              }}
            >
              <FileDownloadOutlinedIcon
                sx={{ fontSize: "1.5rem", marginLeft: "3px" }}
              />
              دانلود مستندات
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid>
        <BorderedLayout
          title={
            <Typography
              sx={{
                color: "#1D4A87",
                fontSize: "1.1rem",
                fontWeight: "bold",
              }}
            >
              مشخصات درخواست پذیرنده
            </Typography>
          }
          backgroundColor="#F9FAFC"
        >
          <Grid container sx={{ padding: "20px" }} gap={"20px"}>
            {/* top section */}
            <Grid item xs={12}>
              <Grid container flexDirection={isMobile ? "column" : "row"}>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    نام شرکت :{" "}
                    <span style={{ color: "#34495E" }}>
                      {collaborationStore?.companyName}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    نام صاحب کسب و کار:{" "}
                    <span style={{ color: "#34495E" }}>
                      {collaborationStore?.businessOwnerName}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    تاریخ درخواست:{" "}
                    <span style={{ color: "#34495E" }}>
                      {collaborationStore?.createDatePersian}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    شناسه ملی:{" "}
                    <span style={{ color: "#34495E" }}>
                      {collaborationStore?.nationalId}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* middle section  */}
            <Grid item xs={12}>
              <Grid container flexDirection={isMobile ? "column" : "row"}>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    شماره ثبت:{" "}
                    <span style={{ color: "#34495E" }}>
                      {collaborationStore?.registrationNumber}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    شماره تلفن:{" "}
                    <span style={{ color: "#34495E" }}>
                      {collaborationStore?.phoneNumber}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    کدپستی:{" "}
                    <span style={{ color: "#34495E" }}>
                      {collaborationStore?.postalCode}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    زمینه فعالیت:{" "}
                    <span style={{ color: "#34495E" }}>
                      {collaborationStore?.activityFieldTitle}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* bottom section */}
            {collaborationStore?.otherActivity && (
              <Grid item xs={12}>
                <Grid container flexDirection={isMobile ? "column" : "row"}>
                  <Grid item xs={3}>
                    <Typography
                      sx={{
                        color: "#9AAFC4",
                        fontSize: "1rem",
                        display: "ruby-text",
                      }}
                    >
                      شرح فعالیت:{" "}
                      <span style={{ color: "#34495E" }}>
                        {collaborationStore?.otherActivity}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid item xs={12}>
              <Grid container flexDirection={isMobile ? "column" : "row"}>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    آدرس:{" "}
                    <span style={{ color: "#34495E" }}>
                      {collaborationStore?.address}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container flexDirection={isMobile ? "column" : "row"}>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    آدرس شعبه:{" "}
                    <span style={{ color: "#34495E" }}>
                      {collaborationStore?.branchAddress}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container flexDirection={isMobile ? "column" : "row"}>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      color: "#9AAFC4",
                      fontSize: "1rem",
                      display: "ruby-text",
                    }}
                  >
                    آدرس سایت:{" "}
                    <span style={{ color: "#34495E" }}>
                      {collaborationStore?.websiteUrl}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </BorderedLayout>
      </Grid>
    </div>
  );
};

export default CollaborationStoreDetail;
